import { socialService } from '../_services';

const getDefaultState = () => {
  return {
    recipe: {},
    current: {}
  }
}

export const socials = {
    namespaced: true,
    state: getDefaultState(),
    actions: {
        resetState ({ commit }) {
            commit('resetState')
        },
        getSocials({ commit }, id) {
            commit('getSocialsRequest');
            socialService.getSocials(id)
                .then(
                    response => commit('getSocialsSuccess', response),
                    error => commit('getSocialsFailure', error)
                );
        },
        addSocial({ commit }, payload) {
            commit('addSocialRequest');
            socialService.add(payload)
                .then(
                    response => commit('addSocialSuccess', response),
                    error => commit('addSocialFailure', error)
                )
        },
        removeSocial({ commit }, payload) {
            commit('removeSocialRequest');
            socialService.remove(payload)
                .then(
                    commit('removeSocialSuccess'),
                    error => commit('removeSocialFailure', error)
                )
            return true;
        }
    },
    mutations: {
        resetState (state) {
            Object.assign(state, getDefaultState())
        },
        getSocialsRequest(state) {
            state.recipe = { loading: true };
        },
        getSocialsSuccess(state, res) {
            state.recipe = Object.values(res);
        },
        getSocialsFailure(state, error) {
            state.recipe = { error };
        },
        addSocialRequest(state, favorite) {
            state.current = { loading: true }
        },
        addSocialSuccess(state, res) {
            state.current = res;
        },
        addSocialFailure(state, error) {
            state.current = { error };
        },
        removeSocialRequest(state) {
            state.current = { loading: true }
        },
        removeSocialSuccess(state) {
            state.current = {};
            return true;
        },
        removeSocialFailure(state, error) {
            state.current = { error };
        }
    }
}